export enum EWithdrawalKycProvider {
  veriff = 'veriff',
}

export enum EWithdrawalKycStatus {
  not_started = 'not_started',
  pending = 'pending',
  resubmission_requested = 'resubmission_requested',
  approved = 'approved',
  declined = 'declined',
  expired = 'expired',
  abandoned = 'abandoned',
  revoked = 'revoked',
}
